(function () {
  'use strict';

  var MOBILE_QUERY = '(max-width: 768px)';
  var SHOW_DELAY = 7000;

  function getYouTubeId(value) {
    if (!value) return '';

    try {
      var url = new URL(value, window.location.origin);
      var host = url.hostname.toLowerCase().replace(/^www\./, '');
      var videoId = '';

      if (host === 'youtu.be') {
        videoId = url.pathname.split('/').filter(Boolean)[0] || '';
      } else if (host === 'youtube.com' || host === 'm.youtube.com') {
        var pathParts = url.pathname.split('/').filter(Boolean);
        if (pathParts[0] === 'shorts') {
          videoId = pathParts[1] || '';
        } else if (url.pathname === '/watch') {
          videoId = url.searchParams.get('v') || '';
        }
      }

      return /^[A-Za-z0-9_-]{11}$/.test(videoId) ? videoId : '';
    } catch (error) {
      return '';
    }
  }

  function createIframe(videoId, expanded) {
    var iframe = document.createElement('iframe');
    var params = expanded
      ? 'autoplay=1&playsinline=1&controls=1&rel=0'
      : 'autoplay=1&mute=1&playsinline=1&controls=0&loop=1&playlist=' + encodeURIComponent(videoId) + '&rel=0&modestbranding=1';

    iframe.src = 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(videoId) + '?' + params;
    iframe.title = expanded ? 'Expanded product video' : 'Floating product video';
    iframe.allow = 'autoplay; encrypted-media; picture-in-picture';
    iframe.allowFullscreen = true;
    iframe.setAttribute('loading', 'eager');
    return iframe;
  }

  function clearPlayer(container) {
    if (container) container.replaceChildren();
  }

  function initializeRoot(root) {
    var videoId = getYouTubeId(root.getAttribute('data-video-url'));
    if (!videoId || window.matchMedia(MOBILE_QUERY).matches) return;

    var miniPlayer = root.querySelector('[data-raelon-floating-video-mini-player]');
    var modal = root.querySelector('[data-raelon-floating-video-modal]');
    var modalPlayer = root.querySelector('[data-raelon-floating-video-modal-player]');
    var expandButton = root.querySelector('[data-raelon-floating-video-expand]');
    var dismissButton = root.querySelector('[data-raelon-floating-video-dismiss]');
    var modalCloseButtons = root.querySelectorAll('[data-raelon-floating-video-modal-close]');
    var dismissed = false;
    var modalOpen = false;
    var showTimer;

    if (!miniPlayer || !modal || !modalPlayer || !expandButton || !dismissButton) return;

    function showPreview() {
      if (dismissed || window.matchMedia(MOBILE_QUERY).matches) return;
      clearPlayer(modalPlayer);
      clearPlayer(miniPlayer);
      miniPlayer.appendChild(createIframe(videoId, false));
      root.hidden = false;
    }

    function closeModal(restorePreview) {
      if (!modalOpen) return;
      modalOpen = false;
      modal.hidden = true;
      clearPlayer(modalPlayer);
      document.body.classList.remove('raelon-floating-product-video-modal-open');
      if (restorePreview && !dismissed && !window.matchMedia(MOBILE_QUERY).matches) showPreview();
    }

    function openModal() {
      if (dismissed || window.matchMedia(MOBILE_QUERY).matches) return;
      clearPlayer(miniPlayer);
      modalPlayer.appendChild(createIframe(videoId, true));
      modal.hidden = false;
      modalOpen = true;
      document.body.classList.add('raelon-floating-product-video-modal-open');
      var modalClose = root.querySelector('.raelon-floating-product-video__close--modal');
      if (modalClose) modalClose.focus();
    }

    function dismissPreview() {
      dismissed = true;
      window.clearTimeout(showTimer);
      closeModal(false);
      clearPlayer(miniPlayer);
      clearPlayer(modalPlayer);
      root.hidden = true;
    }

    expandButton.addEventListener('click', openModal);
    dismissButton.addEventListener('click', dismissPreview);
    modalCloseButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        closeModal(true);
      });
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && modalOpen) closeModal(true);
    });

    window.addEventListener('resize', function () {
      if (!window.matchMedia(MOBILE_QUERY).matches) return;
      window.clearTimeout(showTimer);
      closeModal(false);
      clearPlayer(miniPlayer);
      clearPlayer(modalPlayer);
      root.hidden = true;
    });

    showTimer = window.setTimeout(showPreview, SHOW_DELAY);
  }

  function schedule() {
    document.querySelectorAll('[data-raelon-floating-product-video]').forEach(initializeRoot);
  }

  if (document.readyState === 'complete') {
    schedule();
  } else {
    window.addEventListener('load', schedule, { once: true });
  }
})();
